import { createFileRoute } from '@tanstack/react-router';
import { NotificationsScreen } from '@/screens/notification/NotificationsScreen';

export const Route = createFileRoute('/admin/notifications')({
  component: NotificationsScreen,
});
